import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet's default icon paths (Webpack rewrites URLs so the default icons break)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

// Car icon (SVG) for the driver
export const carIcon = L.divIcon({
  className: 'driver-live-marker',
  html: `<div style="
      width:44px; height:44px; border-radius:50%;
      background:#2563eb; box-shadow:0 4px 12px rgba(0,0,0,0.25);
      display:flex; align-items:center; justify-content:center;
      border:3px solid white;">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
      <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
    </svg>
  </div>`,
  iconSize: [44, 44],
  iconAnchor: [22, 22],
});

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    if (lat != null && lng != null) {
      map.flyTo([lat, lng], map.getZoom(), { duration: 0.75 });
    }
  }, [lat, lng, map]);
  return null;
}

export default function LiveMap({ lat, lng, height = 256, initialZoom = 14 }) {
  const hasLoc = lat != null && lng != null;
  const centerLat = hasLoc ? lat : 28.6139; // Delhi default
  const centerLng = hasLoc ? lng : 77.2090;
  const markerRef = useRef(null);

  return (
    <div style={{ height, width: '100%' }}>
      <MapContainer
        center={[centerLat, centerLng]}
        zoom={initialZoom}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%' }}
        attributionControl={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap contributors'
        />
        {hasLoc && (
          <>
            <Marker position={[lat, lng]} icon={carIcon} ref={markerRef} />
            <Recenter lat={lat} lng={lng} />
          </>
        )}
      </MapContainer>
    </div>
  );
}
